import { render, staticRenderFns } from "./PaymentMethodListItem.vue?vue&type=template&id=2ed5036d&scoped=true&"
import script from "./PaymentMethodListItem.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodListItem.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodListItem.vue?vue&type=style&index=0&id=2ed5036d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed5036d",
  null
  
)

export default component.exports